const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://cantho-api.cgis.asia/",
        media_url: "https://cantho-api.cgis.asia/",
        domainAdminSide: "http://localhost:3000",
        domainUserSide: "http://localhost:3001",
        domainName: "",
        workSpace: "cantho",
        wmsBaseLink: "https://geo.cgis.asia/geoserver/cantho/wms/",
  },
  production: {
      api: "https://cantho-api.cgis.asia/",
      media_url: "https://cantho-api.cgis.asia/",
      domainAdminSide: "https://admin.cantho.cgis.asia",
      domainUserSide: "https://cantho.cgis.asia",
      domainName: "cantho.cgis.asia",
      workSpace: "cantho",
      wmsBaseLink: "https://geo.cgis.asia/geoserver/cantho/wms/",
  },
};

module.exports = apiEnvironment[env];
